import { NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { DateFnsModule } from 'ngx-date-fns';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PublicModule } from '@public/public.module';
import { HeadersInterceptor } from '@core/interceptors/headers.interceptor';
import { configSSO } from '../environments/sso/auth.clientConfiguration.dev';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { IDatePipe } from '@shared/pipes/i-date.pipe';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { TestComponent } from './test/test.component';
import { CallBackComponent } from '@private/test/callback.component';
import { DateInterceptor } from '@core/interceptors/date.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    TestComponent,
    CallBackComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    DateFnsModule,
    SharedModule,
    PublicModule,
  ],
  providers: [
    HttpClient,
    IDatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'dd/MM/yyyy' },
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {
  private readonly oauthService = inject(OAuthService);

  constructor() {
    //* https://inforius.atlassian.net/wiki/spaces/DI/pages/2124120065/Installation+et+param+trage+SSO

    this.oauthService.configure(configSSO);
    this.oauthService.setupAutomaticSilentRefresh({}, 'access_token');
    this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }
}
